/** How finely a computed diff's ranges mark its changes. */
export const CLARITY_MARKDOWN_DIFF_GRANULARITY = {
	/** Every change is marked word by word. */
	WORD: 'word',
	/** At least one changed paragraph is marked as whole lines; the rest word by word. */
	MIXED: 'mixed',
	/** The old body is marked removed and the new body added, each as one range. */
	WHOLE: 'whole',
	/** The bodies are too long to diff or render: no source and no ranges, and the counts cover both whole bodies. */
	UNRENDERED: 'unrendered',
} as const;

export type ClarityMarkdownDiffGranularity =
	(typeof CLARITY_MARKDOWN_DIFF_GRANULARITY)[keyof typeof CLARITY_MARKDOWN_DIFF_GRANULARITY];
